import api from '../../../../services/api';

export async function salvarOrientacoes(idProposta: string | number, texto: string): Promise<void> {
    await api.put(`orientacao-previa/${idProposta}`, {
        orientacoes: texto
    });
}

